module.exports = __webpack_public_path__ + "img/yangxiaochao.97637b71.jpg";